// Size guide modal — called via inline onclick
window.pcOpenSizeGuide = function () {
  var overlay = document.getElementById('pc-sizeguide-overlay');
  if (!overlay) return;
  overlay.classList.add('pc-sizeguide-overlay--open');
  document.body.style.overflow = 'hidden';
  document.addEventListener('keydown', pcSizeGuideEscHandler);
};

window.pcCloseSizeGuide = function (evt) {
  // If called from the overlay's own onclick, only close when the click
  // landed on the overlay itself (the dimmed backdrop), not the modal card.
  if (evt && evt.target !== evt.currentTarget) return;
  var overlay = document.getElementById('pc-sizeguide-overlay');
  if (!overlay) return;
  overlay.classList.remove('pc-sizeguide-overlay--open');
  document.body.style.overflow = '';
  document.removeEventListener('keydown', pcSizeGuideEscHandler);
};

function pcSizeGuideEscHandler(evt) {
  if (evt.key === 'Escape') window.pcCloseSizeGuide();
}

// Thumbnail image swap — called via inline onclick
window.pcSwapImage = function (btn, src) {
  var mainImg = document.getElementById('pc-main-img');
  if (mainImg && src) {
    mainImg.setAttribute('src', src);
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
  }
  document.querySelectorAll('.pc-thumb').forEach(function (t) {
    t.classList.remove('pc-thumb--active');
  });
  btn.classList.add('pc-thumb--active');
};

// Product page interactivity — reads variant data from data attribute, no Liquid in JS
window.pcInit = function (wrapId) {
  var wrap = document.getElementById(wrapId);
  if (!wrap) return;

  var variants = JSON.parse(wrap.getAttribute('data-variants') || '[]');
  var isPreorder = wrap.getAttribute('data-preorder') === 'true';
  var selectedOptions = {};

  // Seed selectedOptions from the currently selected pills
  wrap.querySelectorAll('.pc-pill--selected').forEach(function (pill) {
    selectedOptions[parseInt(pill.dataset.optionPosition)] = pill.dataset.optionValue;
  });

  // Seed selectedOptions from any dropdown selects (per-product option style)
  wrap.querySelectorAll('.pc-select').forEach(function (select) {
    selectedOptions[parseInt(select.dataset.optionPosition)] = select.value;
  });

  function findVariant() {
    return variants.find(function (v) {
      return [v.option1, v.option2, v.option3].filter(Boolean).every(function (opt, i) {
        return selectedOptions[i + 1] === opt;
      });
    });
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function updateVariant(variant) {
    if (!variant) return;
    var variantInput = document.getElementById('pc-variant-id');
    if (variantInput) variantInput.value = variant.id;

    var priceEl = document.getElementById('pc-price');
    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="pc-info__price--sale">' + formatMoney(variant.price) + '</span>' +
          '<span class="pc-info__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    var atc = document.getElementById('pc-atc');
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? (isPreorder ? 'PRE-ORDER' : 'ADD TO CART') : 'SOLD OUT';
    }

    if (variant.featured_image) {
      var mainImg = document.getElementById('pc-main-img');
      if (mainImg) {
        mainImg.setAttribute('src', variant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_1200x.$1'));
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
      }
    }
  }

  // Pill clicks
  wrap.querySelectorAll('.pc-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var pos = parseInt(pill.dataset.optionPosition);
      selectedOptions[pos] = pill.dataset.optionValue;

      var label = document.getElementById('pc-selected-' + pos);
      if (label) label.textContent = pill.dataset.optionValue;

      wrap.querySelectorAll('.pc-pill[data-option-position="' + pos + '"]').forEach(function (p) {
        p.classList.remove('pc-pill--selected');
      });
      pill.classList.add('pc-pill--selected');

      updateVariant(findVariant());
    });
  });

  // Dropdown option selects (per-product option style)
  wrap.querySelectorAll('.pc-select').forEach(function (select) {
    select.addEventListener('change', function () {
      var pos = parseInt(select.dataset.optionPosition);
      selectedOptions[pos] = select.value;
      updateVariant(findVariant());
    });
  });

  // Quantity +/- buttons
  wrap.querySelectorAll('.pc-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('pc-qty');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      input.value = btn.dataset.action === 'plus' ? val + 1 : Math.max(1, val - 1);
    });
  });
};
